import { clientService } from '../services/client.service';
import { useApi } from './use-api';

export function useClient(clientId: string | undefined) {
  const { loading, result: client, error } = useApi(clientService.get, clientId);
  return { loading, client, error };
}
